/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { useTheme } from "@cd2/theme"
import { Spinner } from "@cd2/components"

interface IReloadingOverlayProps {
  isReloading?: boolean
  children: React.ReactNode
}
export function ReloadingOverlay({ isReloading, children }: IReloadingOverlayProps) {
  const { borderRadius } = useTheme()

  return (
    <div
      css={css`
        position: relative;
      `}
    >
      {children}
      <div
        css={css`
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.25);
          transition: 0.3s;
          opacity: ${isReloading ? 1 : 0};
          pointer-events: ${isReloading ? "all" : "none"};
          border-radius: ${borderRadius}px ${borderRadius}px 0 0;
          text-align: center;
        `}
      >
        <div
          css={css`
            position: absolute;
            top: calc(50% - 30px);
            left: calc(50% - 30px);
          `}
        >
          <Spinner size={60} />
        </div>
      </div>
    </div>
  )
}
